<div style="display: contents">
  <h1 class="textS+ confTitle" mat-dialog-title>
    {{this.localiser.get("reports.factorsTitle")}}
  </h1>

  <div mat-dialog-content class="bodyForm">

    <div style="margin-top: 3vh">
      <h4 class="textS+">{{this.localiser.get("reports.emissionFactors")}}</h4>
      <h3 class="textXS">{{this.localiser.get("reports.obtainedFrom")}}<a href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references">Greenhouse Gases Equivalencies Calculator - Calculations and References</a></h3>
      <div style="margin-top: 4vh" class="row rowForm">
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.co2Consumption")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.kwhToConsumedTonCO2" type="number" class="inputWidth" maxlength="15"> {{this.localiser.get("reports.tonsCO2/kWh")}}</h4>
        </div>
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.co2reductions")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.kwhToReducedTonCO2" type="number" class="inputWidth" maxlength="15"> {{this.localiser.get("reports.tonsCO2/kWh")}}</h4>

        </div>
      </div>
      <div class="row rowForm">
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.kilometersDriven1")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.co2ToKilometer" style="width: 25%" type="number" maxlength="15"> {{this.localiser.get("reports.kilometersDriven2")}}</h4>
          <h4 class="textS">{{this.localiser.get("reports.kilowatt-hours")}} * {{((factors.kwhToReducedTonCO2) / (factors.co2ToKilometer)).toFixed(6)}} -> {{this.localiser.get("reports.kilometersDriven3")}}</h4>
        </div>
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.homeEnergy1")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.co2ToHouse" style="width: 25%" type="number" maxlength="15"> {{this.localiser.get("reports.homeEnergy2")}}</h4>
          <h4 class="textS">{{this.localiser.get("reports.kilowatt-hours")}} * {{((factors.kwhToReducedTonCO2) / (factors.co2ToHouse)).toFixed(6)}} -> {{this.localiser.get("reports.homeEnergy3")}}</h4>
        </div>
      </div>
      <div class="row rowForm">
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.urbanTree1")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.co2ToTree" style="width: 25%" type="number" maxlength="15"> {{this.localiser.get("reports.urbanTree2")}}</h4>
          <h4 class="textS">{{this.localiser.get("reports.kilowatt-hours")}} * {{((factors.kwhToReducedTonCO2) / (factors.co2ToTree)).toFixed(6)}} -> {{this.localiser.get("reports.urbanTree3")}}</h4>
        </div>
        <div class="col">
          <h4 class="textS+"><u>{{this.localiser.get("reports.smartphonesCharged1")}}</u></h4>
          <h4 class="textS"><input [(ngModel)]="factors.co2ToPhone" style="width: 25%" type="number" maxlength="15"> {{this.localiser.get("reports.smartphonesCharged2")}}</h4>
          <h4 class="textS">{{this.localiser.get("reports.kilowatt-hours")}} * {{((factors.kwhToReducedTonCO2) / (factors.co2ToPhone)).toFixed(6)}} -> {{this.localiser.get("reports.smartphonesCharged3")}}</h4>
        </div>
      </div>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColorDone textS" mat-button (click)="onSave()">{{this.localiser.get("button.update")}}</button>
    </div>
  </div>

</div>
